import React, {Component} from 'react';
import {Grid, Row, Col, Form, FormGroup, ControlLabel, FormControl, Checkbox, Radio, InputGroup} from "react-bootstrap";
import KlienciService from "../../../../klienciConfig/KlienciService";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import Select from 'react-select'
import TopDostepnosc from "../../../../../componentsTopsa/dostepnosc/TopDostepnosc";
import {TopAlertInformacja, TopAlertOstrzezenie} from "../../../../../componentsTopsa/alerty/TopAlerts";
import {TopButtonAction} from "../../../../../componentsTopsa/buttons/TopButtons";
import TopIf from "../../../../../componentsTopsa/if/TopIf";
import PowiadomieniaService from "../../PowiadomieniaService";
import KierowcyService from "../../../../konfiguracja/zasobyConfig/kierowcy/KierowcyService";
import ReactNotify from "react-notify";
import {Link} from "react-router-dom";

export default class WysylkaForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            adresaci: [
                {value: 'kierowcy', label: 'kierowcy'},
                {value: 'kurs', label: 'klienci na kurs'},
                {value: 'wszyscy', label: 'wszyscy klienci', disabled: true},
                {value: 'trasa', label: 'klienci na trasę', disabled: true},
                {value: 'klient', label: 'dany klient', disabled: true},
            ],
            adresat: {value: 'kierowcy', label: 'kierowcy'},
            kierowcy: [],

            testEmail: "",

            kurs: '',
            trasa: null,
            klient: null,
            wybraniKierowcy: [],
            czyWszyscyKierowcy: false,

            powiadomienieTyp: 'fcm', // fcm / sms / email

            tytulFcm: '',
            trescFcm: '',

            trescEmail: "",

            adresaciNaKurs: [],
            czyPobranoKlientowNaKurs: false

        };
        this.onChangeAdresat = this.onChangeAdresat.bind(this)
        this.renderWyborSzczegolowAdresatow = this.renderWyborSzczegolowAdresatow.bind(this)
        this.onClickWyslij = this.onClickWyslij.bind(this)

        this.onChangeTytulFcm = this.onChangeTytulFcm.bind(this)
        this.onChangeTrescFcm = this.onChangeTrescFcm.bind(this)
    }


    componentDidMount() {
        this.getKierowcy()
    }

    onChangeAdresat(e) {

        if (e) {
            if (e.value === "kierowcy") {
                this.setState({powiadomienieTyp: "fcm"})
            }
            if (e.value === "kurs") {
                this.setState({powiadomienieTyp: "email"})
            }
        }

        this.setState({
            adresat: e,
            kurs: '',
            trasa: null,
            klient: null,
        })

        if (e.value === 'kierowcy') {
            this.getKierowcy()
        }
    }

    getKierowcy = () => {
        KierowcyService.getKierowcyPosiadajcyTelefon().then(function (response) {
            if (response.status < 300) {
            }
            this.setState({
                kierowcy: Array.from(response.data, item => {
                    return {
                        ...item,
                        imieNazwisko: item.imie + ' ' + item.nazwisko
                    }
                })
            })
        }.bind(this))
    }

    renderKierowcaValue(option) {
        return option.imieNazwisko
    }

    renderKierowcaOption(option) {
        return (<div>{option.imieNazwisko} <span className={{color: 'grey', fontSize: '10px'}}><i
            className={'fa fa-phone'}></i>Tel. eBus: {option.nrTelEbus}</span></div>)
    }

    renderWyborSzczegolowAdresatow() {
        if (this.state.adresat.value === 'kierowcy') {
            return (<div>
                <ControlLabel style={{marginRight: '5px'}}>Wybór kierowcy</ControlLabel> <Checkbox inline checked={this.state.czyWszyscyKierowcy}
                                                                                                   onClick={() => {
                                                                                                       this.setState({czyWszyscyKierowcy: !this.state.czyWszyscyKierowcy})
                                                                                                   }}>Wszyscy kierowcy z listy</Checkbox>
                <div>
                    <TopSelect multi={true} disabled={this.state.czyWszyscyKierowcy}
                               onChange={(e) => this.setState({wybraniKierowcy: e})} value={this.state.wybraniKierowcy}
                               options={this.state.kierowcy}
                               valueRenderer={this.renderKierowcaValue}
                               optionRenderer={this.renderKierowcaOption}
                               valueKey={'idKi'} labelKey={'imieNazwisko'}
                    />
                </div>
            </div>)
        }
        else if (this.state.adresat.value === 'kurs') {
            return (<div>
                <ControlLabel>Numer kursu</ControlLabel>
                <FormControl type={'number'} onChange={(e) => this.setState({kurs: e.target.value})} id={"inputKurs"}/>
            </div>)
        }
        else if (this.state.adresat.value === 'trasa') {
            return (<div>
                <ControlLabel>Trasa</ControlLabel>
                <TopSelect onChange={(e) => this.setState({trasa: e})} value={this.state.trasa}
                           options={this.props.trasy} optionRenderer={this.formatTrasaSelect}
                           valueRenderer={this.formatTrasaSelect}
                />
            </div>)
        }
        else if (this.state.adresat.value === 'klient') {
            return (<div>
                <ControlLabel>Klient</ControlLabel>
                <Select.Async value={this.state.klient} onChange={(e) => this.setState({klient: e})} valueKey="idKl"
                              labelKey="info" loadOptions={this.getUsers}
                              backspaceRemoves={true}
                              ignoreAccents={false}
                              placeholder={'Szukaj po nazwisku, pesel, email'}
                />
            </div>)

        }
        else return ''
    }

    getUsers(input) {
        if (!input) {
            return Promise.resolve({options: []})
        }

        return KlienciService.getKlienciBezZdjec(input).then(function (response) {

            let arr = Array.from(response.data.content, item => {
                return {
                    ...item,
                    info: item.imie + ' ' + item.nazwisko + " " + item.pesel + ' ' + item.email,
                    typId: item.idKl
                }
            })
            return {options: arr}
        }.bind(this))
    }

    formatTrasaSelect(option) {
        return <div><span className={'label label-ebus-primary'}>{option.kodTrasy}</span> {option.nazTr} <TopDostepnosc wartoscWarunek={0}
                                                                                                                        wartosc={option.status}
                                                                                                                        czyMarginesLewy={true}/>
        </div>
    }

    onChangeTytulFcm(e) {
        if (e.target.value.length <= 250) {
            this.setState({tytulFcm: e.target.value})
        } else {
            document.getElementById('tytulFcm').value = this.state.tytulFcm
        }
    }

    onChangeTrescFcm(e) {
        if (e.target.value.length <= 1000) {
            this.setState({trescFcm: e.target.value})
        } else {
            document.getElementById('trescFcm').value = this.state.trescFcm
        }
    }

    onChangeTrescEmail(e) {
        if (e.target.value.length <= 2500) {
            this.setState({trescEmail: e.target.value})
        } else {
            document.getElementById('trescEmail').value = this.state.trescEmail
        }
    }

    onClickWyslijTestowaWiadomosc() {
        if (Boolean(this.state.testEmail) && this.state.trescEmail.length > 0) {
            let data = {
                "idKu": this.state.kurs,
                "tresc": this.state.trescEmail
            }
            PowiadomieniaService.wyslijEmailNaTestowyAdres(data, this.state.testEmail).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success("Pomyślnie wysłano testowe powiadomienie email " + this.state.testEmail, "", 3000);
                    this.wyczyscFormularzPoDodaniu()
                }
                else {
                    this.refs.notificator.error("Wystąpił błąd podczas próby wysłania powiadomienia", "", 3000);
                }
            }.bind(this)).catch(function (error) {
                this.refs.notificator.error("Wystąpił błąd podczas próby wysłania powiadomienia", "", 3000);
            }.bind(this))
        }
        else {
            alert("Nie uzupełniono testowego emaila bądź treści wiadomości.")
        }
    }

    onClickWyslij() {

        if (this.state.powiadomienieTyp === 'fcm') {

            if (!Boolean(this.state.trescFcm) || !Boolean(this.state.tytulFcm)) {
                alert('Nie uzupełniono tytułu i/lub treści powiadomienia FCM')
            } else {
                if (this.state.czyWszyscyKierowcy) {
                    this.wyslijFCMDoWszystkichKierowcow()
                }
                else if (this.state.wybraniKierowcy.length > 0) {
                    this.wyslijFcmDoWybranocyhKierowcow()
                } else {
                    alert('Należy wybrać co najmniej jednego kierowcę!')
                }
            }
        }

        if (this.state.powiadomienieTyp === "email") {
            if (this.state.kurs.length > 0 && this.state.trescEmail.length > 0) {
                let data = {
                    "idKu": this.state.kurs,
                    "tresc": this.state.trescEmail
                }
                PowiadomieniaService.wyslijEmailDoKlientowNaKurs(data).then(function (response) {
                    if (response.status < 300) {
                        this.refs.notificator.success("Pomyślnie wysłano powiadomienie email do klientów na kurs " + this.state.kurs, "", 3000);
                        this.wyczyscFormularzPoDodaniu()
                    }
                    else {
                        this.refs.notificator.error("Wystąpił błąd podczas próby wysłania powiadomienia", "", 3000);
                    }
                }.bind(this)).catch(function (error) {
                    this.refs.notificator.error("Wystąpił błąd podczas próby wysłania powiadomienia", "", 3000);
                }.bind(this))
            }
            else {
                alert("Nie uzupełniono numeru kursu bądź treści email!")
            }
        }

    }

    wyslijFcmDoWybranocyhKierowcow() {

        let array = Array.from(this.state.wybraniKierowcy, item => {
            return {
                token: item.fcmToken
            }
        })

        let obj = {
            tokenList: array,
            trescBody: this.state.trescFcm,
            tytul: this.state.tytulFcm
        }

        PowiadomieniaService.wyslijFcmDoDanychKierowcow(obj).then(function (response) {
            console.log(response)
            if (response.status < 300) {
                this.refs.notificator.success("Pomyślnie wysłano powiadomienie do wybranych kierowców/kierowcy", "", 3000);
                this.wyczyscFormularzPoDodaniu()
            }
            else {
                this.refs.notificator.error("Wystąpił błąd podczas próby wysłania powiadomienia", "", 3000);
            }
        }.bind(this))
    }

    wyslijFCMDoWszystkichKierowcow() {
        let obj = {
            trescBody: this.state.trescFcm,
            tytul: this.state.tytulFcm
        }

        PowiadomieniaService.wyslijFcmDoWszystkichKierowcow(obj).then(function (response) {
            console.log(response)
            if (response.status < 300) {
                this.refs.notificator.success("Pomyślnie wysłano powiadomienie do wszystkich kierowców", "", 3000);
                this.wyczyscFormularzPoDodaniu()
            }
            else {
                this.refs.notificator.error("Wystąpił błąd podczas próby wysłania powiadomienia", "", 3000);
            }
        }.bind(this))
    }

    wyczyscFormularzPoDodaniu() {
        this.setState({
            kierowcy: [],

            kurs: '',
            trasa: null,
            klient: null,
            wybraniKierowcy: [],
            czyWszyscyKierowcy: false,

            powiadomienieTyp: 'fcm', // fcm / sms / email

            testEmail: "",

            tytulFcm: '',
            trescFcm: '',

            trescEmail: "",

            adresaciNaKurs: [],

            czyPobranoKlientowNaKurs: false
        })

        if (Boolean(document.getElementById('tytulFcm'))) {
            document.getElementById('tytulFcm').value = ''
        }
        if (Boolean(document.getElementById('trescFcm'))) {
            document.getElementById('trescFcm').value = ''
        }
        if (Boolean(document.getElementById('trescEmail'))) {
            document.getElementById('trescEmail').value = ''
        }
        if (Boolean(document.getElementById('inputKurs'))) {
            document.getElementById('inputKurs').value = ''
        }
    }

    pobierzAdresatowNaKurs(idKu = this.state.kurs) {
        this.setState({czyPobranoKlientowNaKurs: true})
        if (Boolean(idKu)) {
            PowiadomieniaService.pobierzListeKlientowDoPowiadomieniaNaDanyKurs(idKu).then(function (response) {
                if (response) {

                    let klienci = Array.from(response.data).sort((x, y) => {
                        return (y.idkl - x.idkl)
                    })

                    this.setState({
                        adresaciNaKurs: klienci
                    })
                }
            }.bind(this))
        }
        else {
            alert("Proszę uzupełnić kurs")
        }
    }

    render() {

        return (

            <div>
                <ReactNotify ref='notificator'/>
                <fieldset>
                    <div className={'fieldset-label'}>{'Wyślij nowe powiadomienie'}</div>
                    <Form horizontal={true}>
                        <FormGroup>
                            <Col xs={12}>
                                <Radio name={'radioTypPowiadomienia'} inline checked={this.state.powiadomienieTyp === 'fcm'} onClick={() => {
                                    this.setState({powiadomienieTyp: 'fcm', adresat: {value: 'kierowcy', label: 'kierowcy'}})
                                }}>
                                    powiadomienie mobilne</Radio> {' '}
                                <Radio name={'radioTypPowiadomienia'} inline disabled={true} checked={this.state.powiadomienieTyp === 'sms'}
                                       onClick={() => {
                                           this.setState({powiadomienieTyp: 'sms'})
                                       }}>
                                    wiadomość sms</Radio> {' '}
                                <Radio name={'radioTypPowiadomienia'} inline checked={this.state.powiadomienieTyp === 'email'} onClick={() => {
                                    this.setState({powiadomienieTyp: 'email', adresat: {value: 'kurs', label: 'klienci na kurs'}})
                                }}>
                                    wiadomość email</Radio> {' '}
                            </Col>
                            <Col xs={12}>
                                <div className={'add-label-margin'}></div>
                            </Col>
                            <Col xs={12} lg={3}>
                                <ControlLabel>Adresaci powiadomienia</ControlLabel>
                                <TopSelect onChange={this.onChangeAdresat} value={this.state.adresat}
                                           options={this.state.adresaci} clearable={false}/>
                            </Col>
                            {
                                this.state.adresat.value !== 'wszyscy' ?
                                    <Col xs={12} lg={(this.state.adresat.value === 'kurs') ? 1 : (this.state.adresat.value === 'kierowcy') ? 7 : 3}>
                                        {
                                            this.renderWyborSzczegolowAdresatow()
                                        }
                                    </Col>
                                    :
                                    ''
                            }
                        </FormGroup>
                        <TopIf isTrue={this.state.powiadomienieTyp === 'fcm'}>
                            <FormGroup>
                                <Col xs={12}>
                                    <div>
                                        <ControlLabel>Tytuł powiadomienia</ControlLabel><TopAlertInformacja inline={true}
                                                                                                            text={'Ilość znaków: ' + this.state.tytulFcm.length + '/250'}/>
                                    </div>
                                    <div>
                                        <FormControl id={'tytulFcm'} onChange={this.onChangeTytulFcm}/>
                                    </div>
                                </Col>
                                <Col xs={12}>
                                    <div>
                                        <ControlLabel>Treść powiadomienia</ControlLabel><TopAlertInformacja inline={true}
                                                                                                            text={'Ilość znaków: ' + this.state.trescFcm.length + '/1000'}/>
                                    </div>
                                    <div>
                                        <textarea onChange={this.onChangeTrescFcm} style={{maxWidth: '100%'}} className={'form-control'}
                                                  id={'trescFcm'}></textarea>
                                    </div>
                                </Col>
                            </FormGroup>
                        </TopIf>
                        <TopIf isTrue={this.state.powiadomienieTyp === "email"}>
                            <div style={{margin: "5px 0"}}>
                                <div style={{fontStyle: "italic", color: "grey", fontSize: "10px"}}>
                                    Ilość znaków: {this.state.trescEmail.length}/2500
                                </div>
                                <textarea onChange={(e) => this.onChangeTrescEmail(e)}
                                          rows={4}
                                          style={{maxWidth: '100%'}}
                                          className={'form-control'}
                                          id={'trescEmail'}></textarea>
                            </div>
                        </TopIf>
                        <FormGroup>
                            {
                                Boolean(this.state.powiadomienieTyp === "email") ?
                                    <Col xs={5}>
                                        <ControlLabel>
                                            Wiadomość testowa na dany email
                                        </ControlLabel>
                                        <Row>
                                            <Col xs={7}>
                                                <FormControl type={'email'} onChange={(e) => this.setState({testEmail: e.target.value})}
                                                             id={'inputTestowyEmail'}
                                                />
                                            </Col>
                                            <Col xs={5}>
                                                <TopButtonAction
                                                    text={'Wyślij testowe powiadomienie'}
                                                    iconType={'fa fa-send'}
                                                    btnColor={'default'}
                                                    onClick={() => this.onClickWyslijTestowaWiadomosc()}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    :
                                    <Col xs={5}></Col>
                            }
                            <Col xs={7}>
                                <div className={'pull-right'}>
                                    <div className={"add-label-margin"}></div>
                                    <TopButtonAction
                                        text={'Wyślij powiadomienie'}
                                        iconType={'fa fa-send'}
                                        onClick={this.onClickWyslij}
                                        btnDisabled={
                                            (this.state.powiadomienieTyp === "sms")
                                        }
                                    />
                                </div>
                            </Col>
                        </FormGroup>
                    </Form>
                </fieldset>
                {
                    Boolean(this.state.adresat.value === "kurs") ?
                        <div style={{marginTop: "25px"}}>
                            <h4>
                                {
                                    (this.state.adresaciNaKurs.length > 0 && this.state.czyPobranoKlientowNaKurs) ?
                                        "Lista klientów do których zostanie wysłane powiadomienie:"
                                        :
                                        "Kliknij przycisk obok aby pobrać listę klientów"
                                }
                                <TopButtonAction onClick={() => this.pobierzAdresatowNaKurs()}
                                                 text={(this.state.adresaciNaKurs.length > 0) ? "Odśwież" : "Pobierz"}
                                                 iconType={(this.state.adresaciNaKurs.length > 0) ? "fa fa-refresh" : "fa fa-download"}
                                                 btnSize={"xs"}
                                                 elementStyle={{marginLeft: "25px"}}
                                /></h4>

                            {
                                (this.state.adresaciNaKurs.length === 0 && this.state.czyPobranoKlientowNaKurs) ?
                                    <TopAlertOstrzezenie text={"Na ten kurs nie ma zapisanych klientów z adresem email"}/>
                                    :
                                    ''
                            }

                            <table>
                                {
                                    this.state.adresaciNaKurs.map((item, index) =>
                                        <tr>
                                            <td style={{padding: "5px 10px", border: "1px solid #ccc"}}>{index + 1}.</td>
                                            <td style={{padding: "5px 10px", border: "1px solid #ccc"}}><span
                                                className={"label label-ebus-default"}>{item.idkl}</span></td>
                                            <td style={{padding: "5px 10px", border: "1px solid #ccc"}}>
                                                {(Boolean(item.imie) && Boolean(item.nazwisko)) ? item.imie + " " + item.nazwisko :
                                                    <span style={{fontSize: "12px", color: "grey", fontStyle: "italic"}}>klient z nieuzupełnionymi danymi</span>}
                                            </td>
                                            <td style={{padding: "5px 10px", border: "1px solid #ccc"}}>{item.klientemail}</td>
                                            <td style={{padding: "5px 10px", border: "1px solid #ccc"}}>
                                                {
                                                    (item.idkl > 1) ?
                                                        <Link to={'/zarzadzanie-klientami/klient/' + item.idkl} target={'_blank'}>
                                                            <i className={'fa fa-external-link'}></i> Zobacz klienta
                                                        </Link>
                                                        :
                                                        ""
                                                }
                                            </td>
                                        </tr>
                                    )
                                }

                            </table>
                        </div>
                        :
                        ""
                }
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/komunikaty/powiadomienia/components/wysylkaComponents/WysylkaForm.js